import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPageBySlug } from "../../services/servicePage/contentService";

const DynamicPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [title, setTitle] = useState<string>("");
  const [sections, setSections] = useState<{ sectionKey: string; content: string }[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) return;

    getPageBySlug(slug, "en")
      .then((data) => {
        setTitle(data.title);
        setSections(data.sections || []);
      })
      .catch(() => setError("Page not found"));
  }, [slug]);

  if (error) return <div className="text-center mt-10 text-red-500">{error}</div>;

  return (
    <div className="max-w-4xl mx-auto py-10 px-4">
      <h1 className="text-3xl font-bold mb-6 text-center">{title}</h1>

      {sections.map((section) => (
        <div key={section.sectionKey} className="mb-8">
          <div dangerouslySetInnerHTML={{ __html: section.content }} />
        </div>
      ))}
    </div>
  );
};

export default DynamicPage;
